import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { LogSchema } from '../types/Log';

export type ApiLogGetParams = Partial<
    DefaultApiParams & {
        data_inicio: string;
        data_fim: string;
        origem?: number;
        origem_id?: number;
        tipo?: string;
        pesquisar?: string;
    }
>;

const schema = registrosSchema(LogSchema);

export function apiLogGet(params: ApiLogGetParams) {
    return fetchApi({
        endpoint: 'Empresa/Log',
        method: 'get',
        params,
        schema,
    });
}
